import axios from 'axios';

export const state = {
    token: localStorage.getItem('token') || null, // Initialize token from localStorage
    user: JSON.parse(localStorage.getItem('user')) || null,
    role: localStorage.getItem('role') || null,
    currency: localStorage.getItem('currency') || null,
    permissions: JSON.parse(localStorage.getItem('permissions')) || null,
};

export const mutations = {
    SET_TOKEN(state, token) {
        state.token = token;
        localStorage.setItem('token', token);
    },
    SET_USER(state, user) {
        state.user = user;
        localStorage.setItem('user', JSON.stringify(user));
    },
    SET_ROLE(state, role) {
        state.role = role;
        localStorage.setItem('role', role);
    },
    SET_PERMISSIONS(state, permissions) {
        state.permissions = permissions;
        localStorage.setItem('permissions', JSON.stringify(permissions));
    },
    SET_CURRENCY(state, currency) {
        state.currency = currency;
        localStorage.setItem('currency', currency);
    },
    LOGOUT(state) {
        state.token = null;
        state.user = null;
    },
};

export const getters = {
    loggedIn(state) {
        return !!state.user
    },
};

export const actions = {
    login({ commit }, { token, user, role, permissions, currency }) {
        commit('SET_TOKEN', token);
        commit('SET_USER', user);
        commit('SET_ROLE', role);
        commit('SET_PERMISSIONS', permissions);
        commit('SET_CURRENCY', currency);
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    },
    updateUser({ commit }, {user}) {
        commit('SET_USER', user);
    },
    logout({ commit }) {
        commit('LOGOUT');
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('role');
        localStorage.removeItem('permissions');

        // Remove the token from Axios headers
        delete axios.defaults.headers.common['Authorization'];
    },

    initialize({ commit }) {
        // If the token exists in localStorage, commit it to Vuex
        const token = localStorage.getItem('token');
        const user = JSON.parse(localStorage.getItem('user'));

        if (token && user) {
            commit('SET_TOKEN', token);
            commit('SET_USER', user);

            // Set the token in Axios headers
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        }
    }
};
